import { Component, EventEmitter, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Preventivo, Questionario } from '../shared/preventivo';

@Component({
  selector: 'app-step1',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './step1.html',
  styleUrl: './step1.css'
})
export class Step1 {
  @Output() avanti = new EventEmitter<void>();

  questionario : Questionario = {
    ritiro_patente: 'si',
    // circolazione: '',
    copertura_esistente: ''
  };

  constructor(private preventivoService: Preventivo) {}

  showErrorMessage(): boolean {
    return this.isValid() && !(this.questionario.copertura_esistente === 'no');
  }

  avantiStep() {
    this.preventivoService.setQuestionario({ ...this.questionario });
    this.avanti.emit();
  }

  isValid(): boolean {
    return !!this.questionario.copertura_esistente;
          //!!this.questionario.ritiro_patente &&
          // !!this.questionario.circolazione &&
  }
}
